/**
 * What: Defines stable merchant-facing identities for Shopify study arms.
 * Transport / data-flow: Pure helpers derive display labels from immutable arm order and baseline state.
 *
 */
import * as z from 'zod';
export const SHOPIFY_ORIGINAL_PRODUCT_LABEL = 'Original product';
export const shopifyTreatmentIdentityModeSchema = z.enum(['bound', 'unbound']);
/** Why: merchants need one treatment identity that stays consistent across setup and results. */
export function formatShopifyTreatmentLabel(index) {
    return `Option ${String.fromCharCode(65 + index)}`;
}
/** Why: legacy runs may carry filenames or product copy as labels, so results derive identity from arm lineage. */
export function buildShopifyTreatmentIdentityMap(arms, mode = 'bound') {
    const labels = new Map();
    let treatmentIndex = 0;
    for (const arm of arms) {
        if (mode === 'bound' && arm.isBaseline) {
            labels.set(arm.armId, SHOPIFY_ORIGINAL_PRODUCT_LABEL);
            continue;
        }
        labels.set(arm.armId, formatShopifyTreatmentLabel(treatmentIndex));
        treatmentIndex += 1;
    }
    return labels;
}
/** Why: legacy image studies stored the uploaded media URL as the arm label instead of separate metadata. */
export function legacyShopifyTreatmentImageUrl(label, isImageTreatment) {
    if (!isImageTreatment || !URL.canParse(label))
        return null;
    const url = new URL(label);
    const path = new URL(label).pathname.toLowerCase();
    const hasImageExtension = /\.(?:avif|gif|jpe?g|png|webp)$/.test(path);
    return hasImageExtension || path.includes('/media/') ? url.toString() : null;
}
//# sourceMappingURL=shopify-treatment-identity.js.map